// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__ohB6n","item":"PaymentsMobile_item__2A54w","label":"PaymentsMobile_label__ag-Q3","amount":"PaymentsMobile_amount__18pMk"};